module.exports = __webpack_public_path__ + "img/chat-logo.eb0047fa.png";